import {
    COST_CENTRE_ERROR,
    COST_CENTRE_RETRIEVED,
} from '../constants/actions';

const initialState = {
    fetching: false,
    error: '',
    costCenterList: [],
};

export default function costCenterReducer(state = initialState, action) {
    switch (action.type) {
        case COST_CENTRE_ERROR:
        return Object.assign({}, state, {
            fetching: true,
            error: action.payload,
        });

        case COST_CENTRE_RETRIEVED:
        return Object.assign({}, state, {
            fetching: false,
            costCenterList: [...action.payload],
        });

        default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/costCenter.js